import { render, staticRenderFns } from "./PaginatedList.vue?vue&type=template&id=65cbe71e&scoped=true"
import script from "./PaginatedList.vue?vue&type=script&lang=js"
export * from "./PaginatedList.vue?vue&type=script&lang=js"
import style0 from "./PaginatedList.vue?vue&type=style&index=0&id=65cbe71e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cbe71e",
  null
  
)

export default component.exports